import { Stack } from "@tine/designsystem-ui-react";
import type { ContentfulAccordion } from "../../../common/types/cmsTypes";

import CmsAccordion from "./CmsAccordion";

type AccordionListProps = {
   accordionList: ContentfulAccordion[];
   title?: string;
};

const AccordionList = ({ accordionList, title }: AccordionListProps) => {
   const listClassName = "divide-x-0 divide-y divide-ink-border-subtle divide-solid list-none ps-0 w-full";

   return (
      <>
         {title && <h2 className="mb-4 h-5 text-start w-full text-lg/7  mx-0 md:w-3/4 md:mx-auto max-w-[848px]">{title}</h2>}
         {accordionList.map((accordionContent) => (
            <div key={`accordion-${accordionContent.sys.id}`} className="w-full mx-0 md:w-3/4 md:mx-auto max-w-[848px]">
               <Stack gap={6} className="w-full">
                  <ul className={listClassName}>
                     <li>
                        <CmsAccordion accordionContent={accordionContent} />
                     </li>
                  </ul>
               </Stack>
            </div>
         ))}
      </>
   );
};

export default AccordionList;
